<template>
  <v-dialog v-model="AdvCardTwo" width="900">
    <AdCardTwoFullImage ref="fullAdImageTwo"></AdCardTwoFullImage>
    <v-card>
      <!-- <pre>{{articledata}}s</pre> -->
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn color="error" title="Close window" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title pt-5 text-center">{{$t('advertisment.Get your newz out there')}}</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-col md="12">
          <v-img :src="`/frontpageProfile.png`" width="100%" height="400px" contain @click.stop="$refs.fullAdImageTwo.openDialog()"/>
        </v-col>
         <v-row class="ma-0 pa-0">
          <v-col md="12">
            <v-hover>
              <v-card text height="100%" outlined elevation="6" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 0}`">
                <!-- {{$t('advertisment.KEY')}}  -->
                <v-card-text>
                  <p class="title mb-0">{{$t('advertisment.As an logged in user, you will be able to custom make wenewz to your liking')}}</p>
                  <p class="title mb-0">{{$t('advertisment.This you can do through the frontpage editor within your personal pages')}}</p>
                  <p class="title mb-0">{{$t('advertisment.Here you can create different profiles of what you would like to see')}}</p>
                  <p class="title mb-0 pl-3">{{$t('advertisment.Meaning: you can make a profile named sport')}}</p>
                  <p class="title mb-0 pl-3">{{$t('advertisment.ere you select your prioritised locations: ex England')}}</p>
                  <p class="title pl-3 mb-0">{{$t('advertisment.Then lastly you can select the interest tags that you wish to look closer upon')}}</p>
                  <p class="title pl-3 mb-0">{{$t('advertisment.These can be: #sport, #corona and #politics')}}</p>
                  <p class="title pl-3">{{$t('advertisment.Now articles that contain these tags will be prioritised and displayed for you on the frontpage')}}</p>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row> 
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click="closeDialog()">{{$t('general.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AdCardTwoFullImage from "@/components/dialogs/adCardTwoFullImage.vue";
// Import the i18n - This may need to be modified
import messages from "../modules/lang/export";
export default {
  components:{
    AdCardTwoFullImage
  },
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      AdvCardTwo:false,
      // articledata: {}
      reasons: ['Duplicate', 'Harrasment', 'Breaking ToS'],
      reportData:{
        reason:"",
        moreDetails:"",
        articleId: null,
        reportedBy: ""
      }
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
    // this.articledata = articledata;
      this.AdvCardTwo = true;
    },
    // Close the dialog
    closeDialog() {
      this.AdvCardTwo = false;
    }
  }
}
</script>